(function () {
    'use strict';

    var module = angular.module('uwAgenda.login');
    module.controller('ForgotPasswordController', [
        'RegistrationService',
        'HelperService', 
        ForgotPasswordControllerFn
    ]);

    function ForgotPasswordControllerFn(
        RegistrationService, 
        HelperService
        ) {

        var vm = this;

        vm.showSuccessMessage = false;

        vm.sendForgotPasswordEmail = function () {
            HelperService.block(".content");
            RegistrationService.sendForgotPasswordEmail(vm.email, vm.username)
                    .then(function (result) {

                vm.showSuccessMessage = true;
                HelperService.unblock(".content");                

            }, function (error) {
                HelperService.unblock(".content");
            });
        };
    }
})();
